function addSlideClasses(wrapper) {
  if (!wrapper) return;
  wrapper.querySelectorAll(':scope > *').forEach((el) => {
    el.classList.add('swiper-slide');
  });
}

function getOffsetValue(breakpoint) {
  var containerWidth = 0;
  switch (breakpoint) {
    case 0:
      containerWidth = document.body.clientWidth;
      break;
    case 576:
      containerWidth = 540;
      break;
    case 768:
      containerWidth = 720;
      break;
    case 992:
      containerWidth = 960;
      break;
    case 1240:
      containerWidth = 1200;
      break;
    case 1400:
      containerWidth = 1464;
      break;
  }

  return (document.body.clientWidth - containerWidth) / 2;
}

export default function initializeTestimonials() {
  document.querySelectorAll('.block-testimonials__swiper[data-testimonials-free]').forEach((block) => {
    const slider = block.closest('.block-testimonials__slider')?.querySelector('.block-testimonials__swiper');
    if (!slider) return;

    const wrapper = slider.querySelector('.swiper-wrapper');
    addSlideClasses(wrapper);

    import('swiper/bundle').then(({ default: Swiper }) => {
      const swiper = new Swiper(slider, {
        speed: 400,
        loop: false,
        freeMode: {
          enabled: true,
          momentum: true,
          sticky: false,
        },
        slidesPerView: 'auto',
        spaceBetween: 0,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        allowTouchMove: true,
        grabCursor: true,
        resistance: true,
        resistanceRatio: 0.85,
        breakpoints: {
          0: {
            slidesPerView: 1.1,
            spaceBetween: 0,
            slidesOffsetBefore: getOffsetValue(0),
            slidesOffsetAfter: getOffsetValue(0),
          },
          768: {
            slidesPerView: 'auto',
            spaceBetween: 0,
            slidesOffsetBefore: getOffsetValue(768),
            slidesOffsetAfter: getOffsetValue(768),
          },
          992: {
            slidesPerView: 'auto',
            spaceBetween: 0,
            slidesOffsetBefore: getOffsetValue(992),
            slidesOffsetAfter: getOffsetValue(992),
          },
          1240: {
            slidesOffsetBefore: getOffsetValue(1200),
            slidesOffsetAfter: getOffsetValue(1200),
          },
          1400: {
            slidesOffsetBefore: getOffsetValue(1400),
            slidesOffsetAfter: getOffsetValue(1400),
          },
        },
      });

      swiper.autoplay.stop();

      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          swiper.autoplay.start();
          observer.disconnect();
        }
      }, { threshold: 0.1 });

      observer.observe(slider);
    });
  });
}
